import { Box, Stack, Typography } from "@mui/material";
import { PageListLayout } from "../../../shared";
import {
  StockCategoryItems,
  TableHeader,
  StockProductsList,
  StockProductsScrollButton,
} from "../components";
import { useStockItemsList } from "../hooks";

export const StockItemsList = () => {
  const {
    selectedCategoryId,
    groupedCategories,
    tableData,
    itemEdits,
    validationErrors,
    filters,
    editingRowId,
    isSaving,
    search,
    disableClearButton,
    selectionState,
    isBulkVisibilityUpdating,
    handleCategorySelect,
    handleSearchChange,
    handleStatusChange,
    handleVisibilityChange,
    handleClearFilters,
    handleEdit,
    handleCancelEdit,
    handleThresholdChange,
    handleVisibilityToggle,
    onBulkUpdateConfirm,
    updateBulkUpdateRowSelection,
  } = useStockItemsList();

  const breadcrumbs = [
    <Typography key="1" sx={{ fontSize: "14px", fontWeight: 400 }}>
      Stock Items
    </Typography>,
  ];

  return (
    <PageListLayout
      breadcrumbs={breadcrumbs}
      sx={{ p: 0 }}
      pageContent={
        <>
          <Box
            className="sticky-Tab"
            sx={{
              borderBottom: 1,
              borderColor: "divider",
            }}
          >
            <TableHeader
              headerText="Stock Items"
              value={search}
              setGlobalFilter={handleSearchChange}
            />
          </Box>
          <Stack display="flex" flexDirection={{ xs: "column", md: "row" }}>
            <Box
              sx={{
                width: { md: "300px", xs: "100%" },
                backgroundColor: "background.paper",
                p: 1,
                borderRight: "1px solid #DFE8F2",
                overflowY: "auto",
                height: { md: "calc(100vh - 103px)", xs: "auto" },
              }}
            >
              <StockCategoryItems
                selectedCategoryId={selectedCategoryId}
                groupedCategories={groupedCategories}
                onSelect={handleCategorySelect}
              />
            </Box>
            <Box
              sx={{
                flex: 1,
                overflowY: "auto",
                height: "calc(100vh - 103px)",
                pb: 10,
              }}
              id="stock-products-container"
            >
              <StockProductsList
                selectedCategoryId={selectedCategoryId}
                tableData={tableData}
                filters={filters}
                editingRowId={editingRowId}
                itemEdits={itemEdits}
                validationErrors={validationErrors}
                isSaving={isSaving}
                disableClearButton={disableClearButton}
                onStatusChange={handleStatusChange}
                onVisibilityChange={handleVisibilityChange}
                onClearFilters={handleClearFilters}
                onEdit={handleEdit}
                onCancel={handleCancelEdit}
                onThresholdChange={handleThresholdChange}
                onVisibilityToggle={handleVisibilityToggle}
                bulkUpdate={selectionState}
                isBulkVisibilityUpdating={isBulkVisibilityUpdating}
                onBulkUpdateConfirm={onBulkUpdateConfirm}
                updateBulkUpdateRowSelection={updateBulkUpdateRowSelection}
              />
              <StockProductsScrollButton containerId="stock-products-container" />
            </Box>
          </Stack>
        </>
      }
    />
  );
};
